export function getAvatarStyle(name) {
  const colors = [
    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
    "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
    "linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%)",
    "linear-gradient(135deg, #1a2434 0%, #1e9ea8 100%)",
    "linear-gradient(135deg, #182b27 0%, #00bfa5 100%)",
    "linear-gradient(135deg, #1e1e2f 0%, #3a3a66 100%)",
  ];

  // Генерируем индекс на основе имени
  const hash = name
    .split("")
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);
  const colorIndex = hash % colors.length;

  return {
    background: colors[colorIndex],
  };
}

export function getAvatarInitials(name) {
  if (!name) return "?";

  const words = name.split(" ");
  if (words.length === 1) {
    return name.charAt(0).toUpperCase();
  }

  return (
    words[0].charAt(0) + words[words.length - 1].charAt(0)
  ).toUpperCase();
}
